import { getGlobalNavigate } from "utils/navigation";

const url = process.env.REACT_APP_API_URL;

const request = async (requestConfig: any) => {
  const navigate = getGlobalNavigate();

  try {
    let reqBody: any = {
      method: requestConfig.method || "GET",
      headers: requestConfig.headers || {},
      body: requestConfig.body || null,
    };

    if (requestConfig.credentials) {
      reqBody.credentials = requestConfig.credentials;
    }

    const response = await fetch(url + "/" + requestConfig.url, reqBody);
    const data = await response.json();

    if (!response.ok) {
      const errorPayload = {
        status: response.status,
        message: data.message || "Something went wrong.",
        ...data, 
      };

      switch (response.status) {
        case 401:
          errorPayload.message = (data.error && formatValidationErrors(data.error)) || data.message || "Unauthorized.";
          navigate?.("/login");
          break;
        case 403:
          navigate?.("/access-denied");
          errorPayload.message = data.message || "Access denied.";
          break;
        case 404:
          errorPayload.message = data.message || response.statusText; //not found
          break;
        case 422:
          errorPayload.message = data.error ? formatValidationErrors(data.error) : data.message;
          break;
        case 500:
          errorPayload.message = response.statusText || "Internal Server Error"; //server error
          break;
        default:
          errorPayload.message = data.message || "Unexpected error occurred.";
      }

      // Throw the full payload as error
      throw errorPayload;
    }

    return data;
  } catch (error: any) {
    // Check if the error has a status property
    // This is to differentiate between response errors and Network/fetch errors
    // If it has a status, it's likely a response error from backend
    if (error?.status) {
      throw error;
    }
    // Network/fetch error
    throw {
      status: 0,
      message: error.message || "Network error",
      success : false,
      full: null,
    };
  }
};

const formatValidationErrors = (error: { [key: string]: string[] }) => {
  let message = "";
  for (const key in error) {
    if (error[key] && error[key].length > 0) {
      // Append the field/key name followed by each error message on a new line
      message += `\n`;
      message += `${error[key]?.map((msg) => `${msg}`).join("\n")}\n\n`;
    }
  }
  return message.trim();
};

export default request;
